import { Divider as AntDivider, DividerProps } from 'antd';

export const Divider = AntDivider;

export type { DividerProps };
